import React, { useState, useEffect, useRef } from "react"; // 引入 React 核心库以及常用的 hooks：useState（状态管理）和 useEffect（副作用处理）
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Diagram from "@/Components/Diagram"; // 引入流程图主组件，负责渲染和编辑流程图
import Palette from "@/Components/Diagram/Palette"; // 引入图形库组件，提供可拖拽的图形元素
import Overview from "@/Components/Diagram/Overview"; // 引入缩略图组件，用于显示流程图全局视图
import userInfo from "@/Components/user"; // 引入当前用户信息对象，用于记录创建人/更新人
import dayjs from "dayjs"; // 引入 dayjs 库，用于格式化日期时间
import * as go from "gojs";
import flowJosn from "../../../Main/flow.json"; // 引入本地的流程图 JSON 数据（可能是备用或示例数据，文件名有拼写错误 flowJosn -> flowJson）
import tempJosn from "../../../Main/temp.json";
import testJosn from "../../../Main/test.json";
import emptyJosn from "../../../Main/empty.json";
import { useAppContext } from "@/AppContext";
import { getFlow, saveFlow, projectsAll, simulation } from "@/services/common";
import {uploadFile} from "@/services/common";
import {
  message,
  Modal,
  TreeSelect,
  Input,
  Checkbox,
  Row,
  Col,
  Typography,
  notification,
} from "antd";
const { Text } = Typography;
import type { TreeSelectProps } from "antd";
import {
  LoadingOutlined,
  EyeOutlined,
  EditOutlined,
  SaveOutlined,
  FileOutlined,
  CopyOutlined,
  VerticalAlignBottomOutlined,
  VerticalAlignTopOutlined,
  SwapOutlined,
  UndoOutlined,
  RedoOutlined,
  GroupOutlined,
  UngroupOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
  ExpandOutlined,
  ExpandAltOutlined,
  SearchOutlined,
  UnorderedListOutlined,
  PrinterOutlined,
  EditFilled
} from "@ant-design/icons";
import { typeMap, typeMap2, fieldMap2, typeMap3 } from "@/constants/dataMap";
import SelectElementsModal from "@/Components/Diagram/SelectElementsModal";
import elementJson from "@/Components/Diagram/elements.json";
import towerJson from "@/Components/Diagram/elementsData/tower.json";
// import test_Rectisol from "@/constants/test_Rectisol.json";
import test_Rectisol from "@/constants/defaultValue.json";
import { updateFlowthum_Pic,dataURLtoBlob } from "@/config/func";
import { unitMap, materialsValueMap } from "@/constants/dataMap";
import SearchElement from "./searchElement";
import TaskList from "./taskList";

import element from "@/Components/Diagram/newElements.json";
import boiler from "@/Components/Diagram/elementsData/boiler.json";
import comments from "@/Components/Diagram/elementsData/comments.json";
import container from "@/Components/Diagram/elementsData/container.json";
import equipment from "@/Components/Diagram/elementsData/equipment.json";
import heatExchanger from "@/Components/Diagram/elementsData/heatExchanger.json";
import others from "@/Components/Diagram/elementsData/others.json";
import products from "@/Components/Diagram/elementsData/products.json";
import pump from "@/Components/Diagram/elementsData/pump.json";
import reactor from "@/Components/Diagram/elementsData/reactor.json";
import separator from "@/Components/Diagram/elementsData/separator.json";
import tank from "@/Components/Diagram/elementsData/tank.json";
import tower from "@/Components/Diagram/elementsData/tower.json";
import Flash2 from "@/Components/Diagram/elementsData/Flash2.json";
import MultiStreamExchanger from "@/Components/Diagram/elementsData/MultiStreamExchanger.json";
import Mixer from "@/Components/Diagram/elementsData/Mixer.json";

import Drawer from "@/Components/Drawer";
import Result from "@/Pages/Project/Flow/TaskManagement/TaskDate/ResultPageFrame";
import GroupCalModal from "@/Components/Diagram/GroupCalModal";
import isEqual from "lodash/isEqual";

interface ComponentProps {
  allowUpDiagrams?: boolean;
  action?: "deleteDiagram" | "handleData" | "saveDiagram" | null;
  onActionDone?: () => void;
  onReadonlyChange?: (readonly: boolean) => void;
  setAllowUpDiagrams?:(newAllowUpDiagrams)=>void;
  setShowEdit?:(newShowEdit)=>void;
  onEditSuccessVariable?:number;
}

const elementsDatas = {
  boiler,
  comments,
  container,
  equipment,
  ShellAndTubeExchanger: heatExchanger,
  others,
  products,
  pump,
  reactor,
  Splitter: separator,
  tank,
  DistilStrict: tower,
  Flash2,
  Mixer,
  MultiStreamExchanger,
};

// const Component = (props:ComponentProps) =>
const Component: React.FC<ComponentProps> = ({
  allowUpDiagrams,
  action,
  onActionDone,
  onReadonlyChange,
  setAllowUpDiagrams,
  setShowEdit,
  onEditSuccessVariable,
}) => {
  // const {allowUpDiagrams} = props;
  // 定义状态：diagrams 存储流程图实例对象（通常是 mxGraph 的实例）
  const [diagrams, setDiagrams] = useState<any>(null);
  // 定义状态：overview 控制缩略图组件的显示/隐藏，默认为 false（不显示）
  const [overview, setOverview] = useState<boolean>(false);
  // 定义状态：dataSource 存储从后端获取的流程图数据源（包括流程图元数据、图形数据等）
  const [dataSource, setDataSource] = useState<any>(null);
  const [globalData, setGlobalData] = useState<any>(null);
  const { state, actions } = useAppContext();
  const [messageApi, contextHolder] = message.useMessage();
  const [allProjectData, setAllProjectData] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modal2Visible, setModal2Visible] = useState(false);
  const [selectCopyFlowUrl, setSelectCopyFlowUrl] = useState("");
  const [queryAllProjectStatu, setQueryAllProjectStatu] = useState(1); //1:没查，2：正在查，3：查完
  const [overviewVisible, setOverviewVisible] = useState(true);
  const saveDiagramRef = useRef(null);
  const [readonly, setReadonly] = useState<boolean>(() => {
    return !allowUpDiagrams;
  });
  //普通用户不显示编辑模式/激活编辑/导出
  const isNormalUser = userInfo?.role === "user";
  const navigate = useNavigate();
  const [fullScreenViable, setFullScreenViable] = useState(false);
  const [screenSize, setScreenSize] = useState<number>(100);
  const [selectedElements, setSelectedElements] = useState<string[]>([]);
  const params = useParams<{ k: string; f: string; j: string }>();
  const [taskModalVisible, setTaskModalVisible] = useState(false);
  const [currentJsonDataForTask, setCurrentJsonDataForTask] = useState<any>(null);
  const diagramRef = useRef(null);
  const [loadingVariable, setLoadingVariable] = useState(false);
  const [searchElementName, setSearchElementName] = useState(null);
  const [taskListVariable, setTaskListVariable] = useState(true);
  const [selectItem, setSelectItem] = useState(null);
  const [saveTaskVariable, setSaveTaskVariable] = useState<number>(0);
  const [creatTaskVariable, setCreatTaskVariable] = useState<number>(0);
  const [newTreeData, setNewTreeData] = useState(null);
  const [clearSelectVariable, setClearSelectVariable] = useState(false);
  const [taskList, setTaskList] = useState(null);
  const [selectedItem, setSelectedItem] = useState<SelectedNode>({job_id:null,path:[]});
  const [openImportPageVariable,setOpenImportPageVariable] = useState<number>(0);
  const [JobId, setJobId] = useState(null);
  const [queryTaskVariable,setQueryTaskVariable] = useState<number>(0);
  const [closeModalVariable,setCloseModalVariable] = useState<number>(0);
  const [multipleNodes,setMultipleNodes] = useState([]);
  const [changeLinkFlowValue,setChangeLinkFlowValue] = useState(null);
  const [savedJson,setSavedJson] = useState(null);
  const [curResultInfo,setCurResultInfo]=useState<{id:null|number,type:null|'job'|'subJob'}>({
    id:null,
    type:null
  })
  const [curFlowData,setCurFlowData] = useState(null);
  const [queryAllSubJobsToFlowValue,setQueryAllSubJobsToFlowValue] = useState(null);
  const [groups,setGroups] = useState([]);
  const [selectGroup,setSelectGroup] = useState(null);
  const [taskListWidth, setTaskListWidth] = useState(350);//初始宽度350px
  const [isDragging, setIsDragging] = useState(false);
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);
  const [runPartTaskByDiagram,setRunPartTaskByDiagram] = useState({variable:0,nodeData:null});
  const [paramsDrawerVariable,setParamsDrawerVariable] = useState(false);
  const [isNowNeedOpenPramDrawer,setIsNowNeedOpenPramDrawer] = useState(false);
  const isNowNeedOpenPramDrawerRef = useRef(false);

  const streamsBasicParams = [
    {
      p_name: "类型",
      p_engName: "type",
      p_show: false,
      enum: [
        { label: "进料", value: "进料" },
        { label: "出料", value: "出料" },
        { label: "内部", value: "内部" },
      ],
    },
    {
      p_name: "物性计算方法",
      p_engName: "physical_method",
      p_show: true,
      enum: [
        { label: "NRTL", value: "NRTL" },
        { label: "SRK", value: "SRK" },
      ],
    },
    {
      p_name: "相态",
      p_engName: "phase",
      p_show: true,
      enum: [
        { label: "L-液相", value: "L" },
        { label: "V-汽相", value: "V" },
        { label: "VL-汽液两相", value: "VL" },
      ],
    },
    {
      p_name: "计算模式",
      p_engName: "mode",
      p_show: true,
      enum: [
        { label: "TP-温压闪蒸", value: "TP" },
        { label: "VP-汽化率压力闪蒸", value: "VP" },
        { label: "HP-压焓闪蒸", value: "HP" },
      ],
    },
    {
      p_name: "流股属性",
      p_engName: "streamAttribute",
      p_show: true,
      enum: [
        { label: "无", value: "无" },
        { label: "冷流股", value: "冷流股" },
        { label: "热流股", value: "热流股" },
      ],
    },
    {
      p_name: "流量",
      p_engName: "f",
      p_show: true,
      p_unitField: "",
      p_unit: ["kg/h", "kmol/h", "Nm3/h"],
      p_value: "16500.19495",
    },
    {
      p_name: "温度",
      p_engName: "t",
      p_show: true,
      p_unitField: "",
      p_type: "T",
      p_unit: unitMap["T"],
      p_value: "120",
    },
    {
      p_name: "压力",
      p_engName: "p",
      p_show: true,
      p_unitField: "",
      p_type: "P",
      p_unit: unitMap["P"],
      p_value: "50.49",
    },
    {
      p_name: "描述",
      p_engName: "description",
      p_show: false,
      p_value: "",
    },
  ];
  //显示或隐藏结果抽屉
  const [resultDrawOpen, setResultDrawOpen] = useState(false);
  //最近一次"请求打开结果抽屉"的时间戳：打开抽屉的点击往往同时伴随选中项切换，
  //选中项变化的自动关闭副作用需借此识别并跳过（否则抽屉刚打开就被关掉）
  const resultDrawOpenReqTsRef = useRef(0);

  //显示或隐藏组合计算弹窗
  const [groupeCalOpen, setGroupeCalOpen] = useState(false);

  const [notificationApi, notificationContextHolder] = notification.useNotification();
  const NOTICE_KEY = "error-notice";

  const [refreshResVariable, setRefreshResVariable] = useState(0);

  // useEffect(() => {
  //   if (selectedItem.job_id && taskList) {
  //     setTimeout(()=>{
  //       const lll=changeTaskDataToDiagramData();
  //     console.log(lll);
  //     setCurDiagramData(lll)
  //     },1000)
      
  //   }
  // }, [selectedItem.job_id]);

  useEffect(() => {
    if(onEditSuccessVariable>0) 
    {
      // setTaskListVariable(false);
      setQueryTaskVariable(queryTaskVariable+1);
      setCloseModalVariable(closeModalVariable+1);
    }
  }, [onEditSuccessVariable]);

  //转换当前任务数据为流程如数据
  const changeTaskDataToDiagramData = () => {
    const data: any = taskList.find((t: any) => t.job_id === selectedItem.job_id);
    let diagramData: any = {
      class: "GraphLinksModel",
      linkKeyProperty: "key",
      linkFromPortIdProperty: "fromPort",
      linkToPortIdProperty: "toPort",
      nodeDataArray:[],
      linkDataArray:[],
      job_id:selectedItem.job_id,
      job_name:selectedItem.job_name
    };
    const es:any=[]
    
    if(data)
    {
      data.elements.map((ei:any)=>{
        ei.children.map((c:any)=>{
          es.push(c.data)
        })
      })
    }
    const l=data?.streams.map((s:any)=>s.data) || [];
    return {
      ...diagramData,
      nodeDataArray:es,
      linkDataArray:l
    }
  };

  useEffect(() => {
    queryCurFlow();

    //测试数据
    // setDataSource({ data: testJosn, cover: '' });
  }, []);

  useEffect(() => {
    if (onReadonlyChange) {
      onReadonlyChange(readonly);
    }
  }, [readonly, onReadonlyChange]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setFullScreenViable(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, []);

  useEffect(() => {
    if (searchElementName && diagrams) {
      //画面跳转
      const model = diagrams.model;
      let targetPart = null;
      let targetKey = null;
      if (searchElementName.type === "node") {
        const node = model.nodeDataArray.find(
          (n: any) => n.nodeName === searchElementName.name && !n.isGroup,
        );
        if (node) {
          targetKey = node.key;
          targetPart = diagrams.findNodeForKey(targetKey);
        }
      } else if (searchElementName.type === "link") {
        const link = model.linkDataArray.find((l: any) => l.linkName === searchElementName.name);
        if (link) {
          targetKey = link.key;
          targetPart = diagrams.findLinkForKey(targetKey);
        }
      }
      else if (searchElementName.type === "group") 
      {
        const group = model.nodeDataArray.find((l: any) => l.groupName === searchElementName.name);
        if (group) {
          targetKey = group.key;
          targetPart = diagrams.findNodeForKey(targetKey);
        }
      }

      if (targetPart) {
        // 居中显示
        // diagrams.centerRect(targetPart.actualBounds);
        //需要添加延时，否则分组时无法正常居中
        setTimeout(() => 
        {
          diagrams.centerRect(targetPart.actualBounds);
        }, 100);

        // 选中图元
        diagrams.select(targetPart);
      } else {
        messageApi.open({
          type: "error",
          content: "类型有误，查询失败",
        });
      }
      setSearchElementName(null);
    }
  }, [searchElementName, diagrams]);

  // useEffect(() =>
  // {
  //   if(diagrams)
  //   {
  //     const jsonData = JSON.parse(diagrams.model.toJson());
  //     setCurrentJsonDataForTask(jsonData);
  //   }
  // }, [diagrams?.model]);

  useEffect(() => 
  {
    if (!diagrams) return;

    const onModelChange = (evt: go.ChangedEvent) => 
    {
      if(readonly===false)  //编辑模式才生效
      {
        if (evt.change === go.ChangedEvent.Property) 
        {
          // 排除位置、尺寸、角度等布局属性
          const ignoreProps = ['loc', 'location', 'position', 'angle', 'desiredSize', 'scale'];
          const propName = evt.propertyName as string;
          if (ignoreProps.includes(propName)) 
          {
            return;
          }
        }

        if(diagrams.model)
        {
          setCurFlowData(JSON.parse(diagrams.model.toJson()));
        }
      }
    };

    // 监听模型变化
    diagrams.addModelChangedListener(onModelChange);

    // 清理监听器
    return () => 
    {
      diagrams.removeModelChangedListener(onModelChange);
    };
  }, [diagrams]);

  useEffect(() => {
    isNowNeedOpenPramDrawerRef.current = isNowNeedOpenPramDrawer;
  }, [isNowNeedOpenPramDrawer]);

  //拖拽修改侧边栏尺寸
  const handleMouseDown = (e: React.MouseEvent) => 
  {
    e.preventDefault();
    setIsDragging(true);
    startXRef.current = e.clientX;
    startWidthRef.current = taskListWidth;
  };

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;
      const newWidth = startWidthRef.current + (e.clientX - startXRef.current);
      // 限制最小/最大宽度，防止拖出边界（可根据需要调整）
      if (newWidth >= 200 && newWidth <= 800) {
        setTaskListWidth(newWidth);
      }
    };
    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    } else {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    }
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  //查询当前流程图
  const queryCurFlow = () => {
    let token = userInfo.access_token;
    const projectId = params.k;
    const flowId = params.f;

    getFlow(projectId, flowId, token).then(async (res) => {
      if (res.status === 200) {
        if (res.data.flow_data_url) {
          let flowDataUrl = res.data.flow_data_url;
          let global_data = res.data.global_data;
          let response = await fetch(flowDataUrl);
          let jsonData = await response.json();
          //流股颜色统一根据「流股属性」推导，避免刷新后颜色回退/不一致
          const attrColorMap = { "冷流股": "#0000FF", "热流股": "#FF0000", "无": "#000" };
          (jsonData.linkDataArray || []).forEach((link) => {
            const attr = link?.ParamValues?.["流股属性"]?.value;
            if (attr && attrColorMap[attr]) {
              link.lineColor = attrColorMap[attr];
            }
          });
          //若只读模式，分组不显示
          if(readonly===true)
          {
            jsonData.nodeDataArray.forEach(node => {
                if (node.hasOwnProperty('isGroup') && node.isGroup === true) {
                    node.visible = false;
                }
            });
          }

          setDataSource({ data: jsonData, cover: "" });
          setGlobalData(global_data);

          setSavedJson(jsonData);
        } else {
          let global_data = res.data.global_data;
          setGlobalData(global_data);
          setDataSource({ data: emptyJosn, cover: "" });
        }
      } else {
        messageApi.open({
          type: "error",
          content: `查询失败：${res.status}`,
        });
        let global_data = {
          globle_physical_method: "",
          materials: [],
        };
        setGlobalData(global_data);
        setDataSource({ data: emptyJosn, cover: "" });
      }
    });
  };

  // 切换只读/编辑模式的函数
  const toggleReadOnlyMode = () => {
    setReadonly(!readonly); // 将 readonly 状态取反
    // 打印当前切换后的模式（由于 setState 是异步的，这里打印的是旧值，但可反映意图）
    // console.log(`已切换到${readonly ? "编辑" : "只读"}模式`);
  };

  // 获取与节点相连的流股（方向：in/out）
  const getRelatedLinks = (diagrams: any, nodeKey: string, direction: "in" | "out") => {
    const model = diagrams.model;
    const linkDataArray = model.linkDataArray;
    return linkDataArray.filter((link: any) => {
      if (direction === "in") return link.to === nodeKey;
      return link.from === nodeKey;
    });
  };

  // 生成节点的默认 ParamValues
  const generateNodeDefaultParamValues = (nodeData: any, diagrams: any) => {
    const paramValues = {};
    const type = nodeData.type;
    const name = nodeData.elementName;
    let params: any[] = [];
    let nodeName = nodeData.nodeName ?? "";

    // 获取参数定义（与 Diagram 中 openInputParams 逻辑一致）
    if (element.filter((item: any) => item.typeID == type).length > 0) {
      params = element.filter((item: any) => item.typeID == type)[0].params;
    }
    if (elementsDatas[type] !== undefined) {
      const matched = elementsDatas[type].filter((item: any) => item.name == name);
      if (matched.length > 0 && matched[0].params) {
        params = params.concat(matched[0].params);
      }
    }

    // 为每个参数生成默认值
    params.forEach((param) => {
      const paramName = param.p_name;
      if (param.p_children && Array.isArray(param.p_children) && param.p_children.length > 0) {
        // 处理 Ns/No/output_f 等特殊子项
        if (param.p_engName === "Ns" || param.p_engName === "No" || param.p_engName === "output_f") {
          const nodeKey = nodeData.key;
          const direction = param.p_engName === "Ns" ? "in" : "out";
          const links = getRelatedLinks(diagrams, nodeKey, direction);
          const p_children = links.map((link: any, index: number) => {
            // 分流器“输出流量”：非摩尔分率（frac）时需保留一个空值，最后一个输出流股不赋初值
            const isEmptyLast =
              param.p_engName === "output_f" &&
              test_Rectisol.inputs.elements.find((item) => item.name === nodeName)?.params?.[
                "f_unit"
              ] !== "frac" &&
              index === links.length - 1;
            const getDefaultValue = () =>
              (nodeName &&
                test_Rectisol.inputs.elements.find((item) => item.name === nodeName)?.params[
                  param.p_engName
                ]?.[
                  test_Rectisol.inputs.elements
                    .find((item) => item.name === nodeName)
                    ?.[
                      param.p_engName === "Ns" ? "inputStreams" : "outputStreams"
                    ].findIndex((item) => item.name === (link.text || link.linkName || ""))
                ]) ??
              param.p_children.find(
                (item) =>
                  item.p_engName === "进料位置" ||
                  item.p_engName === "出料位置" ||
                  item.p_engName === "输出流量",
              ).p_value ??
              "";
            const defaultValue = isEmptyLast ? "" : getDefaultValue();
            return {
              流股: {
                value: link.text || link.linkName || "",
                desValue: link.text || link.linkName || "",
                show: true,
                engName: "streamName",
                readonly: true,
              },
              [param.p_engName === "Ns" ? "进料位置" : param.p_engName === "No" ? "出料位置" : "输出流量"]: {
                value: defaultValue,
                desValue: defaultValue,
                show: true,
                engName:
                  param.p_engName === "Ns"
                    ? "进料位置"
                    : param.p_engName === "No"
                      ? "出料位置"
                      : "输出流量",
              },
            };
          });
          paramValues[paramName] = {
            show: param.p_show ?? false,
            engName: param.p_engName,
            p_children,
          };
        } else if (param.p_engName === "stream_type") {
          let defaultChildren = [{}];
          for (let i = 0; i < param.p_children.length; i++) {
            let defaultChild = {
              value: param.p_children[i].p_value,
              desValue: param.p_children[i].p_value,
              show: param.p_children[i].p_show,
              engName: param.p_children[i].p_engName,
            };
            defaultChildren[0][param.p_children[i].p_name] = defaultChild;
          }

          paramValues[paramName] = {
            show: param.p_show ?? false,
            engName: param.p_engName,
            p_children: defaultChildren,
          };
        } else {
          // 普通 p_children，初始为空数组
          paramValues[paramName] = {
            show: param.p_show ?? false,
            engName: param.p_engName,
            p_children: [],
          };
        }
      } else if (param.enum && param.enum.length > 0) {
        // 枚举类型：默认值取第一个
        paramValues[paramName] = {
          value: param.enum[0].value,
          desValue: param.enum[0].value,
          show: param.p_show ?? false,
          engName: param.p_engName,
        };
      } else if (param.p_unit && param.p_unit.length > 0) {
        // 有单位字段：value 默认空字符串，单位取第一个
        paramValues[paramName] = {
          // value: param.p_value ?? '',
          value:
            (nodeName &&
              test_Rectisol.inputs.elements.find((item) => item.name === nodeName)?.params[
                param.p_engName
              ]) ??
            param.p_value ??
            "",
          desValue:
            (nodeName &&
              test_Rectisol.inputs.elements.find((item) => item.name === nodeName)?.params[
                param.p_engName
              ]) ??
            param.p_value ??
            "",
          unit: param.p_unit[0],
          show: param.p_show ?? false,
          engName: param.p_engName,
          unitField: param.p_unitField ?? null,
        };
      } else {
        // 普通输入框
        paramValues[paramName] = {
          // value: param.p_value ?? '',
          value:
            (nodeName &&
              test_Rectisol.inputs.elements.find((item) => item.name === nodeName)?.params[
                param.p_engName
              ]) ??
            param.p_value ??
            "",
          desValue:
            (nodeName &&
              test_Rectisol.inputs.elements.find((item) => item.name === nodeName)?.params[
                param.p_engName
              ]) ??
            param.p_value ??
            "",
          show: param.p_show ?? false,
          engName: param.p_engName,
        };
      }
    });
    return paramValues;
  };

  // 生成连接线的默认 ParamValues
  const generateLinkDefaultParamValues = (linkData: any) => {
    const paramValues = {};
    streamsBasicParams.forEach((param) => {
      const paramName = param.p_name;
      if (param.enum && param.enum.length > 0) {
        paramValues[paramName] = {
          value: param.enum[0].value,
          desValue: param.enum[0].value,
          show: param.p_show ?? false,
          engName: param.p_engName,
        };
      } else if (param.p_unit && param.p_unit.length > 0) {
        paramValues[paramName] = {
          value: param.p_value ?? "",
          desValue: param.p_value ?? "",
          unit: param.p_unit[0],
          show: param.p_show ?? false,
          engName: param.p_engName,
          unitField: param.p_unitField ?? null,
        };
      } else {
        paramValues[paramName] = {
          value: param.p_value ?? "",
          desValue: param.p_value ?? "",
          show: param.p_show ?? false,
          engName: param.p_engName,
        };
      }
    });
    return paramValues;
  };

  // 生成连接线的默认组分摩尔分率
  const generateLinkDefaultMaterials = (globalData: any) => {
    const materials = {};
    if (globalData && globalData.materials) {
      for (let i = 0; i < globalData.materials.length; i++) {
        const name = globalData.materials[i].formula;
        materials[name] = {
          molar_frac: materialsValueMap[name] ?? "",
          desValue: materialsValueMap[name] ?? "",
          cas: globalData.materials[i].cas_code,
          name: globalData.materials[i].formula,
          chineseName: globalData.materials[i].name,
        };
      }
    }
    return materials;
  };

  // 确保所有图元都有 ParamValues
  const ensureAllParamValues = (diagrams: any, globalData: any) => {
    if (!diagrams) return;
    const model = diagrams.model;
    const nodeDataArray = model.nodeDataArray;
    const linkDataArray = model.linkDataArray;

    // 处理节点
    for (const node of nodeDataArray) {
      if (node.isGroup) continue; // 跳过分组节点
      if (node.ParamValues === undefined && (node.elementName || node.nodeName)) {
        const defaultValues = generateNodeDefaultParamValues(node, diagrams);
        model.setDataProperty(node, "ParamValues", defaultValues);
      }
    }

    // 处理连接线
    for (const link of linkDataArray) {
      if (link.linkName || link.text) {
        // 处理ParamValues
        if (
          link.ParamValues === undefined ||
          (typeof link.ParamValues === "object" && Object.keys(link.ParamValues).length === 0)
        ) {
          const defaultValues = generateLinkDefaultParamValues(link);
          model.setDataProperty(link, "ParamValues", defaultValues);
        }
        // 处理materials
        if (
          link.materials === undefined ||
          (typeof link.materials === "object" && Object.keys(link.materials).length === 0)
        ) {
          const defaultMaterials = generateLinkDefaultMaterials(globalData);
          model.setDataProperty(link, "materials", defaultMaterials);
        }
      }
    }
  };

  // 保存流程图数据的函数
  const saveDiagram = async (isSetPage = false,isNeedCreatTask?:boolean) => {
    if (readonly) {
      //只读模式执行保存任务
      setSaveTaskVariable(saveTaskVariable + 1);
    } else {
      //编辑模式执行保存流程图
      if (!diagrams) {
        return false;
      }

      setLoadingVariable(true);

      if (diagramRef.current) {
        diagramRef.current.clearAllLinkHighlights();
        diagramRef.current.clearAllNodeHighlights();
        diagramRef.current.clearAllLinkFlow();
        
        // //分组功能，勿删
        // diagramRef.current.clearAllGroupVisible();
      }

      // 先确保所有图元都有默认参数值
      ensureAllParamValues(diagrams, globalData);

      let token = userInfo.access_token;
      let flowId = state.curFlow["id"];
      let projectId = state.curFlow["project_id"];

      await updateFlowthum_Pic({ project_id: projectId, id: flowId }, false);
      return saveFlow(projectId, flowId, JSON.parse(diagrams.model.toJson()), token).then(
        async (res) => {
          if (res.status === 200) {
            messageApi.open({
              type: "success",
              content: "保存成功",
            });


            setSavedJson(JSON.parse(diagrams.model.toJson()));
            setLoadingVariable(false);

            if (isSetPage) {
              if (projectId && flowId && globalData) {
                // 跳转到新的参数查看页面路由（自定义路径，建议和现有格式统一）
                onActionDone?.();
                navigate(`/project/${projectId}/flow/${flowId}/params`, { state: { globalData } });
              }
            }

            if(isNeedCreatTask)
            {
              // //创建计算任务
              // setCreatTaskVariable(creatTaskVariable+1)
            }

            return true;
          } else {
            messageApi.open({
              type: "error",
              content: `保存失败：${res.status}`,
            });
            setLoadingVariable(false);
            return false;
          }
        },
      );
    }
  };

  const copyDiagram = () => {
    if (queryAllProjectStatu === 1) {
      queryAllProject();
    } else if (queryAllProjectStatu === 2) {
      messageApi.open({
        type: "error",
        content: "正在查询，请稍等",
      });
    } else if (queryAllProjectStatu === 3) {
      if (allProjectData) {
        setSelectCopyFlowUrl("");
        setModalVisible(true);
      }
    }
  };

  const selectCopyFlow = (value, option) => {
    if (option.flow_data_url) {
      setSelectCopyFlowUrl(option.flow_data_url);
    } else {
      messageApi.open({
        type: "error",
        content: `流程：${option.title} 暂无流程图`,
      });
    }
  };

  const queryAllProject = async () => {
    let token = userInfo.access_token;
    setQueryAllProjectStatu(2);
    projectsAll({ 
      owner_id: userInfo.id,
      // owner_id: 1 
    }, token).then(async (res) => {
      if (res.status === 200) {
        let newProjectData = res.data.data;
        setAllProjectData(newProjectData);
        setQueryAllProjectStatu(3);
        setModalVisible(true);
      } else {
        setQueryAllProjectStatu(1);
        messageApi.open({
          type: "error",
          content: "查询失败，请点击按钮重新查询",
        });
      }
    });
  };

  const confirmCopyDiagram = async () => {
    if (selectCopyFlowUrl !== "") {
      let response = await fetch(selectCopyFlowUrl);
      let jsonData = await response.json();
      setDataSource(null);
      setTimeout(() => {
        setDataSource({ data: jsonData, cover: "" });
      }, 100);
      setModalVisible(false);
    } else {
      messageApi.open({
        type: "error",
        content: "请选择要粘贴的流程",
      });
    }
  };

  const importDiagram = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".json"; // 只允许选择JSON文件
    // 监听文件选择事件
    fileInput.onchange = (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (!file) return;
      // 验证文件类型
      if (file.type !== "application/json" && !file.name.endsWith(".json")) {
        alert("请选择有效的JSON文件");
        return;
      }
      // 读取文件内容
      const reader = new FileReader();
      reader.onload = (event) => {
        // 解析JSON内容
        const importJson = JSON.parse(event.target?.result as string);
        // 更新流程图数据源

        setDataSource(null);
        setTimeout(() => {
          setDataSource({ data: importJson, cover: "" });
        }, 100);

        // setDataSource({ data: importJson, cover: '' });
      };
      // 以文本方式读取文件
      reader.readAsText(file);
    };
    // 触发文件选择对话框
    fileInput.click();
    // 清理临时创建的DOM元素
    setTimeout(() => {
      fileInput.remove();
    }, 100);
  };

  const exportDiagram = () => {
    let flowName = state.curFlow["name"];

    let jsonData_json = JSON.parse(diagrams.model.toJson());
    // jsonData_json["modelData"] = {"position": "0 0"};
    let jsonData = JSON.stringify(jsonData_json);
    const blob = new Blob([jsonData], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = flowName; // 下载的文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const exportPic = async() =>
  {
    if (diagrams)
    {
      let flowName = state.curFlow["name"];
      //PDF

      //导出svg
      const svgElement = diagrams.makeSvg({
        scale: 1,          // 不缩放，保证清晰度
        background: "white"
      });

      const serializer = new XMLSerializer();
      let svgString = serializer.serializeToString(svgElement);
      if (!svgString.includes('xmlns')) 
      {
        svgString = svgString.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
      }

      // 3. 构建完整的打印 HTML，强制一页显示
      const printHtml = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <title>${flowName}</title>
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            body {
              display: flex;
              justify-content: center;
              align-items: center;
              background: white;
            }
            /* 打印样式：强制缩放至一页，无额外边距 */
            @media print {
              body {
                margin: 0;
                padding: 0;
              }
              @page {
                size: auto;      /* 保持纸张大小（默认 A4） */
                margin: 0mm;     /* 移除页边距，腾出更多空间 */
              }
              .svg-container {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100vh;   /* 占满视口高度 */
                page-break-after: avoid;
                page-break-inside: avoid;
              }
              svg {
                width: 100%;
                height: auto;
                max-height: 100vh;
                object-fit: contain;  /* 保持比例，完整显示 */
              }
            }
          </style>
        </head>
        <body>
          <div class="svg-container">
            ${svgString}
          </div>
          <script>
            window.onload = () => {
              // 稍等片刻确保 SVG 渲染完成，然后自动调起打印
              setTimeout(() => {
                window.print();
                window.onafterprint = () => window.close();
              }, 200);
            };
          <\/script>
        </body>
        </html>
      `;

      // 4. 打开新窗口并打印
      const printWindow = window.open("", "_blank");
      if (!printWindow) {
        messageApi.open({ type: "error", content: "请允许弹出窗口，以便导出 PDF" });
        return;
      }
      printWindow.document.write(printHtml);
      printWindow.document.close();

      //图片
      // if (typeof diagrams.makeImageData === 'function') 
      // {
      //   const scale = 0; // 分辨率倍数
      //   const imgData = diagrams.makeImageData({
      //     scale: 1,
      //     background: 'white',
      //     returnType: "image/png",
      //     // bounds: diagrams.documentBounds,
      //     // useCORS: true,
      //     // logging: false,
      //   });
      //   if (imgData) {
      //     const link = document.createElement('a');
      //     link.download = `${flowName}.png`;
      //     link.href = imgData;
      //     link.click();
      //   }
      // }
    }
  }

  const deleteDiagram = () => {
    if (!readonly) {
      setDataSource({ data: emptyJosn, cover: "" });
    } else {
      setReadonly(false);
    }
  };

  const lastDiagram = () => {
    if (diagrams && diagrams.undoManager) {
      diagrams.undoManager.undo();
    }
  };

  const nextDiagram = () => {
    if (diagrams && diagrams.undoManager) {
      diagrams.undoManager.redo();
    }
  };

  const groupDiagram = () => {
    if (diagrams && diagrams.commandHandler) {
      diagrams.commandHandler.groupSelection();
    }
  };

  const ungroupDiagram = () => {
    if (diagrams && diagrams.commandHandler) {
      diagrams.commandHandler.ungroupSelection();
    }
  };

  const fullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setFullScreenViable(true);
    } else {
      document.exitFullscreen();
      setFullScreenViable(false);
    }
  };

  const adaptDiagram = () => {
    if (diagrams && diagrams.zoomToFit) {
      diagrams.zoomToFit();
    }
  };

  const handleData = async () => {
    const jsonData = JSON.parse(diagrams.model.toJson());
    setCurrentJsonDataForTask(jsonData);
    setTaskModalVisible(true);
  };

  const onTaskSuccess = async () => {
    const saveSuccess = await saveDiagram();
    if (saveSuccess) {
      const flowId = state.curFlow["id"];
      navigate(`/project/${state.curFlow.project_id}/flow/${flowId}/task`);
    }
  };

  useEffect(() => {
    saveDiagramRef.current = saveDiagram;
  }, [saveDiagram]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "s") {
        e.preventDefault();
        if (saveDiagramRef.current) {
          saveDiagramRef.current();
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    if (action === "deleteDiagram") {
      deleteDiagram();
      onActionDone?.();
    } else if (action === "handleData") {
      handleData();
      setTaskModalVisible(true);
      onActionDone?.();
    } else if (action === "saveDiagram") {
      saveDiagram(true);
      // onActionDone?.();

      // // 校验参数，避免跳转失败
      // let flowId = state.curFlow["id"];
      // let projectId = state.curFlow["project_id"];
      // if (projectId && flowId && globalData)
      // {
      //   // 跳转到新的参数查看页面路由（自定义路径，建议和现有格式统一）
      //   navigate(`/project/${projectId}/flow/${flowId}/params`,{state:{globalData}});
      // }
    }
  }, [action, onActionDone]);

  //提交组合计算
  const onGroupeTaskSuccess = async () => {
    alert("触发提交");

    // const saveSuccess = await saveDiagram();
    // if (saveSuccess) {
    //   const flowId = state.curFlow["id"];
    //   navigate(`/project/${state.curFlow.project_id}/flow/${flowId}/task`);
    // }
  };

  //抽屉打开时关闭其他抽屉
  const closeOtherDrawer = (drawerName:string) =>
  {
    if(drawerName==="paramsDrawer")
    {
      setResultDrawOpen(false);
    }
    else if(drawerName==="resultDraw")
    {
      setCloseModalVariable(closeModalVariable+1);
    }
  };

  //结果抽屉的关闭规则（与参数抽屉保持一致）：
  //切换任务、切换所选单元/流股、切换流程时自动关闭，避免继续展示上一个对象的结果
  useEffect(() => {
    //若这次选中项变化是"查看结果"按钮点击连带引起的（刚请求打开抽屉），则不关闭
    if (Date.now() - resultDrawOpenReqTsRef.current < 500) {
      return;
    }
    setResultDrawOpen(false);
  }, [selectedItem?.job_id, selectedItem?.type, selectedItem?.item_name, state.curFlow?.id]);

  // 返回组件的 JSX 结构
  return (
    <>
      {contextHolder}

      {loadingVariable ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(150,170,200,0.3)",
            zIndex: 1100,
            fontSize: 44,
            fontWeight: "bold",
            color: "#1b6ae7",
          }}
        >
          <LoadingOutlined style={{ fontSize: 48, marginRight: 30 }} />
          <span>{readonly?"计算中":"保存中"}</span>
        </div>
      ) : null}

      <div style={{ display: "flex", flexDirection: "row", flex: 1, height: "100%"}}>
        {diagrams &&
        JSON.parse(diagrams.model.toJson()) &&
        (JSON.parse(diagrams.model.toJson()).nodeDataArray.length > 0 ||
          JSON.parse(diagrams.model.toJson()).linkDataArray.length > 0) ? (
          <div style={{ display: taskListVariable ? "flex" : "none", width: taskListWidth, height: "100%",position:"relative",flexShrink:0}}>
            <TaskList
              jsonData={JSON.parse(diagrams.model.toJson())}
              state={state}
              close={() => {
                setTaskListVariable(false);
              }}
              selectElement={(newElementType, newElement) => 
              {
                setSelectItem(newElement);
                if (newElementType && newElement) {
                  setSearchElementName({ name: newElement.text, type: newElementType });
                  //更改画面尺寸
                  setScreenSize(100);
                  if (diagrams) {
                    diagrams.scale = 100 / 100;
                  }
                }
              }}
              setIsNowNeedOpenPramDrawer={(newIsNowNeedOpenPramDrawer)=>{
                setIsNowNeedOpenPramDrawer(newIsNowNeedOpenPramDrawer);}}
              saveTaskVariable={saveTaskVariable}
              newTreeData={newTreeData}
              clearSelectVariable={clearSelectVariable}
              setClearSelectVariable={()=>{setClearSelectVariable(!clearSelectVariable);}}
              setTaskListFunc={(newTaskList) => {
                if(newTaskList.length>0)
                {
                  actions.setFlowMode("查看流程");
                }
                setTaskList(newTaskList);}}
              setSelectedItemFunc={(newSelectedItem) => {setSelectedItem(newSelectedItem);}}
              selectedNodeByFlow={selectedItem}
              resultDrawOpen={resultDrawOpen}
              setResultDrawOpen={(newResultDrawOpen)=>{
                if(newResultDrawOpen===true)
                {
                  resultDrawOpenReqTsRef.current = Date.now();
                }
                setResultDrawOpen(newResultDrawOpen);
                if(newResultDrawOpen===true)
                {
                  closeOtherDrawer("resultDraw");
                }
              }}
              setGroupeCalOpen={setGroupeCalOpen}
              flowJsonData = {curFlowData}
              // flowJsonData = {dataSource?.data}
              // flowJsonData = {JSON.parse(diagrams.model.toJson())}
              notificationApi={notificationApi}
              notificationKey={NOTICE_KEY}
              openImportPageVariable={openImportPageVariable}
              setJobId = {(newJobId)=>{setJobId(newJobId);}}
              setAllowUpDiagrams={(newAllowUpDiagrams)=>{
                setAllowUpDiagrams(newAllowUpDiagrams);}}
              taskListVariable={taskListVariable}
              queryTaskVariable={queryTaskVariable}
              setCurResultInfo={setCurResultInfo}
              setChangeLinkFlowValue = {(newChangeLinkFlowValue)=>{setChangeLinkFlowValue(newChangeLinkFlowValue)}}
              readonly={readonly}
              setReadonly = {(newReadonly)=>{setReadonly(newReadonly);}}
              saveDiagram={async()=>{if (!readonly) await saveDiagram(false,true);}}
              setSearchElementName={(newSearchElementName)=>
                {
                  //元件居中
                  setSearchElementName(newSearchElementName);
                  //更改画面尺寸
                  setScreenSize(100);
                  if (diagrams) {
                    diagrams.scale = 100 / 100;
                  }
                }}
              queryAllSubJobsToFlowValue={queryAllSubJobsToFlowValue}
              groups={groups}
              taskListWidth={taskListWidth}
              setTaskListSelectGroup={(newSelectGroup)=>
                {
                  setSelectGroup(newSelectGroup);
                  
                  if(newSelectGroup)
                  {
                    //元件居中
                    setSearchElementName({ name: newSelectGroup.groupName, type: "group" });

                    // //更改画面尺寸
                    // setScreenSize(100);
                    // if (diagrams) {
                    //   diagrams.scale = 100 / 100;
                    // }
                  }
                }}
              runPartTaskByDiagram={runPartTaskByDiagram}
              setRefreshResVariable={()=>{
                // 计算完成后无条件触发结果刷新（不依赖抽屉是否打开），
                // 否则抽屉关闭期间计算结果时，单元操作/流股/完整输入输出不会更新
                setRefreshResVariable(refreshResVariable+1);
              }}
              setCloseModalVariable={()=>{                
                setCloseModalVariable(closeModalVariable+1);}}
              upParamDrawer={(upParamDrawerNode)=>{
                setIsNowNeedOpenPramDrawer(true);
              }}
              clearHigh={()=>{
                if (diagramRef.current) 
                {
                  diagramRef.current.clearAllLinkHighlights();
                  diagramRef.current.clearAllNodeHighlights();
                  diagramRef.current.clearAllLinkFlow();
                }
              }}
            />
            <div
              style={{
                position: "absolute",
                right: 0,
                top: 0,
                width: 4,
                height: "100%",
                cursor: "col-resize",
                background: "transparent",
                zIndex: 10,
                userSelect: "none",
              }}
              onMouseDown={handleMouseDown}
            />
          </div>
        ) : null}

        <div
          className="diagram_component"
          style={{ padding: 0, margin: 0, flex: 1, overflowX: "hidden",overflowY:"hidden" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: 25,
              background: "#EEE",
              paddingLeft: 15,
              border: "solid #BBB",
              borderWidth: "1px 0 1px 0",
            }}
          >
            {/* {readonly && ( */}
              <button
                onClick={() => {
                  setTaskListVariable(!taskListVariable);
                }}
                style={{
                  width: 90,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 1px",
                  background: taskListVariable ? "#BBB" : "#EEE",
                  color: taskListVariable ? "#000" : "#5F5F5F",
                  fontSize: 12,
                }}
              >
                <UnorderedListOutlined style={{ marginRight: 10 }} />
                计算任务
              </button>
            {/* )} */}
            {!isNormalUser && (
            <button
              onClick={async () => {
                //先执行保存，后执行后续
                if (!readonly) 
                {
                  if(!isEqual(JSON.parse(diagrams.model.toJson()),savedJson))
                  {
                    await saveDiagram();
                  }
                  setReadonly(true);
                }
              }}
              style={{
                width: 90,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 1px",
                background: readonly ? "#BBB" : "#EEE",
                color: readonly ? "#000" : "#5F5F5F",
                fontSize: 12,
              }}
            >
              <EyeOutlined style={{ marginRight: 10 }} />
              只读模式
            </button>
            )}
            {allowUpDiagrams && !isNormalUser && (
              <button
                onClick={() => {
                  setReadonly(false);
                }}
                disabled={!allowUpDiagrams}
                style={{
                  width: 90,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background: !readonly ? "#BBB" : "#EEE",
                  color: !readonly ? "#000" : "#5F5F5F",
                  fontSize: 12,
                }}
              >
                <EditOutlined style={{ marginRight: 10 }} />
                编辑模式
              </button>
            )}
            {!readonly && (
              <button
                onClick={async() => 
                {
                  //先执行保存
                  if(!isEqual(JSON.parse(diagrams.model.toJson()),savedJson))
                  {
                    await saveDiagram();
                  }

                  //打开页面
                  // 跳转到新的参数查看页面路由（自定义路径，建议和现有格式统一）
                  onActionDone?.();
                  const projectId = params.k;
                  const flowId = params.f;
                  navigate(`/project/${projectId}/flow/${flowId}/params`, { state: { globalData } });

                }}
                style={{
                  width: 90,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background:"#EEE",
                  color:"#5F5F5F",
                  fontSize: 12,
                }}
              >
                <EditFilled style={{ marginRight: 10 }} />
                快捷编辑
              </button>
            )}

            {!allowUpDiagrams && !isNormalUser && (
              <button
                onClick={() => 
                {
                  if (diagramRef.current) 
                  {
                    diagramRef.current.clearAllLinkHighlights();
                    diagramRef.current.clearAllNodeHighlights();
                    diagramRef.current.clearAllLinkFlow();
                    
                    // //分组功能，勿删
                    // diagramRef.current.clearAllGroupVisible();
                  }
                  setShowEdit(true)
                }}
                style={{
                  width: 90,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background:"#EEE",
                  color:"#5F5F5F",
                  fontSize: 12,
                }}
              >
                <EditOutlined style={{ marginRight: 10 }} />
                激活编辑
              </button>
            )}
            {!readonly ?(
              <button
                onClick={() => {
                  saveDiagram();
                }}
                style={{
                  width: 70,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background: "#EEE",
                  color: "#5F5F5F",
                  fontSize: 12,
                }}
              >
                <SaveOutlined style={{ marginRight: 10 }} />
                保存
              </button>
            ):null}
            <button
              onClick={() => {
                setOverviewVisible(!overviewVisible);
              }}
              style={{
                width: 70,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: overviewVisible ? "#BBB" : "#EEE",
                color: overviewVisible ? "#000" : "#5F5F5F",
                fontSize: 12,
              }}
            >
              <SwapOutlined style={{ marginRight: 10 }} />
              缩略图
            </button>
            {!readonly && (
              <button
                onClick={deleteDiagram}
                style={{
                  width: 70,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background: "#EEE",
                  color: "#5F5F5F",
                  fontSize: 12,
                }}
              >
                <FileOutlined style={{ marginRight: 10 }} />
                清空
              </button>
            )}
            {/* {!readonly && (
              <button
                onClick={lastDiagram}
                style={{
                  width: 70,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background: "#EEE",
                  color: "#5F5F5F",
                  fontSize: 12,
                }}
              >
                <UndoOutlined style={{ marginRight: 10 }} />
                撤销
              </button>
            )} */}
            {/* {!readonly && (
              <button
                onClick={nextDiagram}删除
                style={{
                  width: 70,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background: "#EEE",
                  color: "#5F5F5F",
                  fontSize: 12,
                }}
              >
                <RedoOutlined style={{ marginRight: 10 }} />
                重做
              </button>
            )} */}
            {!readonly && (
              <button
                onClick={groupDiagram}
                style={{
                  width: 90,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background: "#EEE",
                  color: "#5F5F5F",
                  fontSize: 12,
                }}
              >
                <GroupOutlined style={{ marginRight: 10 }} />
                组合工艺段
              </button>
            )}
            {!readonly && (
              <button
                onClick={ungroupDiagram}
                style={{
                  width: 90,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background: "#EEE",
                  color: "#5F5F5F",
                  fontSize: 12,
                }}
              >
                <UngroupOutlined style={{ marginRight: 10 }} />
                删除工艺段
              </button>
            )}
            {/* {!readonly && (
              <button
                onClick={copyDiagram}
                style={{
                  width: 70,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background: queryAllProjectStatu !== 2 ? "#EEE" : "#BBB",
                  color: "#5F5F5F",
                  fontSize: 12,
                }}
              >
                {queryAllProjectStatu === 2 ? (
                  <LoadingOutlined style={{ marginRight: 10 }} />
                ) : (
                  <CopyOutlined style={{ marginRight: 10 }} />
                )}
                粘贴
              </button>
            )} */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: 140,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: "#EEE",
                color: "#5F5F5F",
                fontSize: 12,
              }}
            >
              <ExpandAltOutlined style={{ marginLeft: 10, marginRight: 10 }} />
              缩放
              <Input
                value={screenSize}
                suffix="%"
                onChange={(e) => {
                  const newValueStr = e.target.value;
                  if (newValueStr === "") {
                    messageApi.open({
                      type: "error",
                      content: "请输入数字",
                    });
                  } else {
                    const newValue = Number(newValueStr);
                    if (!isNaN(newValue)) {
                      setScreenSize(newValue);
                    } else {
                      messageApi.open({
                        type: "error",
                        content: "请输入数字",
                      });
                    }
                  }
                }}
                onPressEnter={(e) => {
                  const newValueStr = e.target["value"];
                  let newValue = null;
                  if (newValueStr !== "") {
                    newValue = Number(newValueStr);
                    if (Number.isNaN(newValue)) {
                      newValue = null;
                    }
                  }
                  if (newValue) {
                    setScreenSize(newValue);
                    //此处更改画面缩放尺寸
                    if (diagrams) {
                      diagrams.scale = newValue / 100;
                    }
                  } else {
                    messageApi.open({
                      type: "error",
                      content: "请输入数字",
                    });
                  }
                }}
                style={{
                  marginLeft: 10,
                  width: 65,
                  height: "80%",
                  borderRadius: 0,
                  fontSize: 12,
                  paddingBottom: 0,
                  paddingTop: 0,
                  color: "#5F5F5F",
                }}
              />
            </div>
            <button
              onClick={fullScreen}
              style={{
                width: 70,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: "#EEE",
                color: "#5F5F5F",
                fontSize: 12,
              }}
            >
              {fullScreenViable ? (
                <FullscreenOutlined style={{ marginRight: 10 }} />
              ) : (
                <FullscreenExitOutlined style={{ marginRight: 10 }} />
              )}
              {fullScreenViable ? "窗口" : "全屏"}
            </button>
            <button
              onClick={adaptDiagram}
              style={{
                width: 90,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: "#EEE",
                color: "#5F5F5F",
                fontSize: 12,
              }}
            >
              <ExpandOutlined style={{ marginRight: 10 }} />
              适应屏幕
            </button>
            {!readonly?(
              <button
                onClick={importDiagram}
                style={{
                  width: 70,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background: "#EEE",
                  color: "#5F5F5F",
                  fontSize: 12,
                }}
              >
                <VerticalAlignBottomOutlined style={{ marginRight: 10 }} />
                导入
              </button>
            ):null}
            {!isNormalUser && (
            <button
              onClick={exportDiagram}
              style={{
                width: 70,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: "#EEE",
                color: "#5F5F5F",
                fontSize: 12,
              }}
            >
              <VerticalAlignTopOutlined style={{ marginRight: 10 }} />
              导出
            </button>
            )}
            {/* <button
              onClick={exportPic}
              style={{
                width: 100,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: "#EEE",
                color: "#5F5F5F",
                fontSize: 12,
              }}
            >
              <PrinterOutlined style={{ marginRight: 10 }} />
              打印流程图
            </button> */}

            {diagrams ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  width: 225,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background: "#EEE",
                  color: "#5F5F5F",
                  fontSize: 12,
                }}
              >
                <SearchOutlined style={{ marginLeft: 10, marginRight: 10 }} />
                查找
                <SearchElement
                  style={{
                    marginLeft: 10,
                    width: 130,
                    height: 18.39,
                    borderRadius: 0,
                    fontSize: 12,
                    paddingBottom: 0,
                    paddingTop: 0,
                    color: "#5F5F5F",
                  }}
                  diagrams={diagrams}
                  searchElementChange={(newSearchElement,newSelectType) => {
                    if(readonly)
                    {
                      //只读模式
                      if(JobId)
                      {
                        let task = taskList.find(item=>item.job_id===JobId);
                        if(newSelectType==="node")
                        {
                          let node = (task.elements.map(obj => obj["children"])).flat().find(item=>item.name===newSearchElement).data;
                          if(node)
                          {
                            setSelectItem(node);
                            setSelectedItem(
                              {
                                category:typeMap3[node.type],
                                data:node,
                                item_name:newSearchElement,
                                job_id:JobId,
                                job_name:task.jobname,
                                path:[task.jobname,"单元操作",typeMap3[node.type],newSearchElement],
                                type:"element"
                              }
                            );
                          }
                        }
                        else if(newSelectType==="link")
                        {
                          let link = task.streams.find(item=>item.name===newSearchElement).data;
                          if(link)
                          {
                            setSelectItem(link);
                            setSelectedItem(
                              {
                                data:link,
                                item_name:newSearchElement,
                                job_id:JobId,
                                job_name:task.jobname,
                                path:[task.jobname,"liugu",newSearchElement],
                                type:"stream"
                              }
                            );
                          }
                        }
                      }
                    }

                    //元件置于中央
                    setSearchElementName({ name: newSearchElement, type: newSelectType });
                    //更改画面尺寸
                    setScreenSize(100);
                    if (diagrams) {
                      diagrams.scale = 100 / 100;
                    }
                  }}
                />
              </div>
            ) : null}

            {/* <button
              onClick={handleData}
              style={{width:70,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
            >测试</button> */}
            {/* <button
              onClick={toggleReadOnlyMode}
              style={{width:60,height:"100%",border:"1px solid #BBB",background:"#EEE",color:"#5F5F5F",fontSize:12}}
              // style={{ marginLeft: '15px', backgroundColor: readonly ? '#4CAF50' : '#FF9800' }}
            >
              {readonly ? '切换到编辑模式' : '切换到只读模式'}
            </button> */}
          </div>
          {/* 只有当 dataSource 有值时（即数据已加载），才渲染流程图相关组件 */}
          {dataSource ? (
            <>
              {/* 流程图主组件，接收以下 props：
                diagrams: 当前 mxGraph 实例
                settings: 包含 readonly 设置
                setDiagrams: 更新 diagrams 状态的函数（可能用于接收实例引用）
                dataSource: 初始流程图数据（图形结构）
            */}
              <div onContextMenu={(e) => e.preventDefault()}>
                <Diagram
                  diagrams={diagrams}
                  settings={{
                    readonly: readonly,
                  }}
                  setDiagrams={setDiagrams}
                  dataSource={dataSource.data}
                  overview={overviewVisible}
                  globalData={globalData}
                  onScaleChange={(scalePercent) => setScreenSize(scalePercent)}
                  diagramsRef={diagramRef}
                  doubleClick={{ selectItem: selectItem, diagram: diagrams ,isTitle:selectItem?false:true,isRealDoubleClick:isNowNeedOpenPramDrawerRef.current}}
                  upTreeData={(newElement, newElementType, newNodeType) => 
                  {
                    if(selectedItem)
                    {
                      if(newElement.nodeName)
                      {
                        if(selectedItem.item_name===newElement.nodeName)
                        {
                          newElement.isRun = selectedItem?.data?.isRun ?? false;
                        }
                      }
                    }
                    newElement.isRun = selectedItem?.data?.isRun ?? false;
                    setNewTreeData({
                      element: newElement,
                      elementType: newElementType,
                      nodeType: newNodeType,
                    });
                  }}
                  setClearSelectVariable={() => {
                    setClearSelectVariable(!clearSelectVariable);
                  }}
                  taskList={taskList}
                  selectedItem={selectedItem}
                  setSelectedNode={(newSelectedNode) => {
                    setSelectedItem(newSelectedNode);
                  }}
                  setSearchElementName={(newSearchElement) => {
                    setSearchElementName(newSearchElement);
                  }}
                  setOpenImportPage={()=>{setOpenImportPageVariable(openImportPageVariable+1);}}
                  closeModalVariable={closeModalVariable}
                  setMultipleNodes={(newMultipleNodes)=>{setMultipleNodes(newMultipleNodes);}}
                  changeLinkFlowValue={changeLinkFlowValue}
                  setTaskListGroups={(newGroups)=>{setGroups(newGroups);}}
                  taskListSelectGroup={selectGroup}
                  setRunPartTaskByDiagram={(nodeData)=>{setRunPartTaskByDiagram({variable:runPartTaskByDiagram.variable+1,nodeData:nodeData});}}
                  saveDiagram = {()=>{saveDiagram();}}
                  taskListVariable={taskListVariable}
                  taskListWidth={taskListWidth}
                  closeOtherDrawer={(drawerName)=>{closeOtherDrawer(drawerName);}}
                  setIsNowNeedOpenPramDrawer={(newIsNowNeedOpenPramDrawer)=>{
                    setIsNowNeedOpenPramDrawer(newIsNowNeedOpenPramDrawer);}}

                  //查看计算结果
                  setSubName={(newSubName)=>{}}
                  setCurResultInfo={setCurResultInfo}
                  setResultDrawOpen={(newResultDrawOpen)=>
                  {
                    if(newResultDrawOpen===true)
                    {
                      resultDrawOpenReqTsRef.current = Date.now();
                    }
                    setResultDrawOpen(newResultDrawOpen);
                    if(newResultDrawOpen===true)
                    {
                      closeOtherDrawer("resultDraw");
                    }
                  }}
                />
              </div>
              {/* 如果 diagrams 实例已存在，则渲染 Palette 和 Overview 组件 */}
              {diagrams && (
                <>
                  {/* Palette 组件提供拖拽图形库，仅当非只读模式时才显示（!readonly） */}
                  {!readonly && diagrams && (
                    <div
                      style={{
                        height: 180,
                        width: "100%",
                        position: "absolute",
                        bottom: "0px",
                        zIndex: 100,
                      }}
                    >
                      <Palette diagrams={diagrams} />
                    </div>
                  )}
                  {/* Overview 缩略图组件，始终显示（但受 show 属性控制），show 为 overview 状态 */}
                  <Overview diagrams={diagrams} show={overview} className="flowOverview" />
                </>
              )}
            </>
          ) : (
            ""
          )}{" "}
          {/* 如果 dataSource 为空，则不渲染任何内容 */}
        </div>
      </div>

      <Modal
        closable={false}
        centered={true}
        footer={null}
        width={500}
        className={"modal"}
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
        }}
      >
        <div style={{ marginBottom: 20, fontSize: 20, fontWeight: "bold", color: "#1b6ae7" }}>
          粘贴流程图
        </div>
        <div>
          <TreeSelect
            showSearch
            allowClear={false}
            defaultOpen={false}
            multiple={false}
            treeDefaultExpandAll={true}
            virtual={false}
            style={{ width: "100%" }}
            styles={{
              popup: {
                root: { maxHeight: 400, overflow: "auto" },
              },
            }}
            placeholder="请选择流程"
            onSelect={selectCopyFlow}
            treeData={(allProjectData || []).map(({ id, name, flows, ...rest }) => ({
              ...rest,
              title: name,
              value: id,
              disabled: flows,
              children: (flows || []).map(({ name: flowName, id, ...flowRest }) => ({
                ...flowRest,
                title: flowName,
                value: id,
              })),
            }))}
          />
        </div>
        <div style={{ height: 32 }}>
          <button
            onClick={() => {
              {
                setModalVisible(false);
              }
            }}
            style={{
              position: "absolute",
              right: 25,
              bottom: 10,
              width: 88,
              height: 32,
              border: 0,
              borderRadius: 5,
              background: "#FF4D4F",
              color: "#FFF",
              fontSize: 14,
            }}
          >
            取消
          </button>
          <button
            onClick={() => {
              confirmCopyDiagram();
            }}
            style={{
              position: "absolute",
              right: 138,
              bottom: 10,
              width: 88,
              height: 32,
              border: 0,
              borderRadius: 5,
              background: "#1b6ae7",
              color: "#FFF",
              fontSize: 14,
            }}
          >
            确认
          </button>
        </div>
      </Modal>

      {notificationContextHolder}
      {selectedItem.job_id && (
        <>

          <style>{`
            .resultDrawer 
            {
              z-index: 200 !important;
            }
          `}
          </style>

          {/* 结果抽屉 */}
          <Drawer
            className="resultDrawer"
            open={resultDrawOpen}
            onOpenChange={(newResultDrawOpen)=>{
              if(newResultDrawOpen===true)
              {
                resultDrawOpenReqTsRef.current = Date.now();
              }
              setResultDrawOpen(newResultDrawOpen);
              if(newResultDrawOpen===true)
              {
                closeOtherDrawer("resultDraw");
              }
            }}
            title={null}
            // triggerText="点击打开"
            width={taskListVariable ? `calc(100vw - ${taskListWidth}px)` : "100vw"}
            children={
              <div>
                {/* <Result job_id={selectedItem.job_id} /> */}
                {/* <Result job_id={1524} type={curResultInfo.type} /> */}
                {/* <Result job_id={curResultInfo.type==='job'?1524:curResultInfo.id} type={curResultInfo.type} /> */}
                <Result subJobid={selectedItem.job_id} item_name={selectedItem.item_name} job_id={curResultInfo.id} type={curResultInfo.type} refreshResVariable={refreshResVariable} DataSource={dataSource}/>
              </div>
            }
          />
          {/* 组合计算弹窗 */}
          <GroupCalModal
            visible={groupeCalOpen}
            jsonData={changeTaskDataToDiagramData()}
            onClose={() => setGroupeCalOpen(false)}
            onSuccess={onGroupeTaskSuccess}
            state={state}
            notificationApi={notificationApi}
            notificationKey={NOTICE_KEY}
            setSelectedItem={setSelectedItem}
            selectElement={(newElementType, newElement) => 
            {
              setSelectItem(newElement);
              if (newElementType && newElement) {
                setSearchElementName({ name: newElement.text, type: newElementType });

                //更改画面尺寸
                setScreenSize(100);
                if (diagrams) {
                  diagrams.scale = 100 / 100;
                }
              }
            }}
            setLoadingVariable={(newLoadingVariable)=>{setLoadingVariable(newLoadingVariable)}}
            setQueryTask={()=>{setQueryTaskVariable(queryTaskVariable+1);}}
            multipleNodes={multipleNodes}
            setChangeLinkFlowValue = {(newChangeLinkFlowValue)=>{setChangeLinkFlowValue(newChangeLinkFlowValue)}}
            setQueryAllSubJobsToFlowValue={(newQueryAllSubJobsToFlowValue)=>{setQueryAllSubJobsToFlowValue(newQueryAllSubJobsToFlowValue);}}
          />
        </>
      )}

      {/* <SelectElementsModal
        // notificationApi={notificationApi}
        // notificationKey={notificationKey}
        visible={taskModalVisible}
        jsonData={currentJsonDataForTask}
        onClose={() => setTaskModalVisible(false)}
        onSuccess={onTaskSuccess}
        state={state}
      /> */}
    </>
  );
};

export default Component; // 导出组件，供其他模块使用
